var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'c-block-list-borger-dk-text-custom',
		'w-5col >=768:w-6col max-w-full mx-auto' ],attrs:{"id":("borger-dk-text-" + _vm._uid)}},[(_vm.title)?_c('BaseH2',{staticClass:"text-primary-button mb-sm",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.content)?_c('div',{staticClass:"s-rich-text w-full",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }